<template>
  <div v-show="isShowModal">
    <div class="spx-modal h-100 justify-content-center">
      <div class="spx-modal-body mx-auto p-0 reg-pop">
        <div>
          <Form ref="registerForm" @submit="signup()">
            <div
              class="modal-dialog modal-dialog-centered modal-xl"
              style="margin: 0px">
              <div class="modal-content">
                <div class="modal-header px-md-5 border-0">
                  <h5 class="modal-title" id="loginModalLabel">
                    Free Registration
                  </h5>
                  <button
                    type="button"
                    class="btn-close"
                    v-on:click="closedModal()"></button>
                </div>
                <div
                  class="modal-body pt-0"
                  style="height: 637px; overflow-y: scroll">
                  <div class="form-style">
                    <div class="col-lg-12 col-sm-12 mb-3">
                      <a v-on:click="removeImage()"
                        ><img
                          src="/img/close-circle-red.svg"
                          width="16"
                          style="
                            float: right;
                            position: relative;
                            right: 277px;
                            top: 17px;
                          "
                      /></a>
                      <div class="text-center mb-4">
                        <img
                          :src="
                            detail.images && detail.images != null
                              ? detail.images
                              : '/images/placeholder-image.jpg'
                          "
                          id="preview"
                          class="img-thumbnail"
                          style="
                            border-radius: 100px;
                            width: 150px;
                            height: 150px;
                          " /><br />
                        <div id="msg"></div>
                        <div
                          id="image-form"
                          style="margin: 0 auto; width: 150px">
                          <input
                            type="file"
                            class="file"
                            id="pickFile"
                            v-on:change="onChange($event)"
                            accept="image/*"
                            style="display: none" />
                          <div class="input-group my-1">
                            <input
                              type="text"
                              class="form-control"
                              disabled
                              placeholder="Upload File"
                              id="file"
                              style="display: none" />
                            <div
                              class="changePic"
                              style="
                                bottom: -25px;
                                cursor: pointer;
                                margin-left: 13px !important;
                              ">
                              <label for="pickFile" style="cursor: pointer">
                                Upload Photo</label
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>First Name</label>
                          <span class="text-danger">*</span>
                          <Field
                            type="text"
                            id="first-name"
                            class="form-control"
                            name="firstname"
                            placeholder="First Name"
                            v-model="detail.first_name"
                            @keypress="$helperService.maxInput($event, 15)"
                            @keyup="trimMaxLength('first_name', 15)"
                            rules="required:first name"
                            :validateOnInput="true" />
                        </div>
                        <ErrorMessage name="firstname" class="validation-msg" />
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Middle Name</label>
                          <!-- <input type="text" class="form-control" /> -->
                          <Field
                            type="text"
                            id="middle-name"
                            class="form-control"
                            name="middlename"
                            placeholder="Middle Name"
                            v-model="detail.middle_name"
                            @keypress="$helperService.maxInput($event, 15)"
                            @keyup="trimMaxLength('middle_name', 15)"
                            rules=":Middle Name"
                            :validateOnInput="true" />
                        </div>
                        <ErrorMessage
                          name="middlename"
                          class="validation-msg" />
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Last name</label>
                          <span class="text-danger">*</span>
                          <Field
                            type="text"
                            id="last-name"
                            class="form-control"
                            name="lastname"
                            placeholder="Last Name"
                            v-model="detail.last_name"
                            @keypress="$helperService.maxInput($event, 25)"
                            @keyup="trimMaxLength('last_name', 25)"
                            rules="required:last name"
                            :validateOnInput="true" />
                        </div>
                        <ErrorMessage name="lastname" class="validation-msg" />
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Gender</label>
                          <span class="text-danger">*</span>
                          <div class="d-flex">
                            <div class="form-check me-2">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="gender_type"
                                id="male"
                                v-on:click="selectGender('M')" />
                              <label class="form-check-label" for="male"
                                >Male
                              </label>
                            </div>
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="gender_type"
                                id="female"
                                v-on:click="selectGender('F')" />
                              <label class="form-check-label" for="female">
                                Female
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-5">
                        <div class="form-group align-items-center mb-3">
                          <label>Date of Birth</label>
                          <span class="text-danger">*</span>
                          <div class="mb-3">
                            <!-- <Field
                              type="text"
                              name="dob"
                              placeholder="Select date of birth"
                              rules="required: date of birth"
                              v-model="detail.dob_validate"
                              :validateOnInput="true"
                              v-slot="{ field }"
                            >
                            
                              <ErrorMessage name="dob" class="text-danger" /> -->

                            <!-- </Field> -->
                            <CustomDatepicker
                              @update="changeBOD($event)"
                              :modelValue="detail.dob_validate"
                              ref="dobDatePicker"
                              v-bind="field" />
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-md-4 mb-2 form-group align-items-center mb-3">
                        <label for="">Height</label>
                        <span class="text-danger">*</span>
                        <Field
                          as="select"
                          class="form-control form-select"
                          placeholder="Select Height"
                          id="height1"
                          name="height"
                          v-model="detail.height"
                          rules="required: height,true"
                          :validateOnInput="true">
                          <option value="">Select Height</option>
                          <option value="139">
                            {{ $helperService.getHeight(139) }}
                          </option>
                          <option value="142">
                            {{ $helperService.getHeight(142) }}
                          </option>
                          <option value="144">
                            {{ $helperService.getHeight(144) }}
                          </option>
                          <option value="147">
                            {{ $helperService.getHeight(147) }}
                          </option>
                          <option value="149">
                            {{ $helperService.getHeight(149) }}
                          </option>
                          <option value="152">
                            {{ $helperService.getHeight(152) }}
                          </option>
                          <option value="154">
                            {{ $helperService.getHeight(154) }}
                          </option>
                          <option value="157">
                            {{ $helperService.getHeight(157) }}
                          </option>
                          <option value="160">
                            {{ $helperService.getHeight(160) }}
                          </option>
                          <option value="162">
                            {{ $helperService.getHeight(162) }}
                          </option>
                          <option value="165">
                            {{ $helperService.getHeight(165) }}
                          </option>
                          <option value="167">
                            {{ $helperService.getHeight(167) }}
                          </option>
                          <option value="170">
                            {{ $helperService.getHeight(170) }}
                          </option>
                          <option value="172">
                            {{ $helperService.getHeight(172) }}
                          </option>
                          <option value="175">
                            {{ $helperService.getHeight(175) }}
                          </option>
                          <option value="177">
                            {{ $helperService.getHeight(177) }}
                          </option>
                          <option value="180">
                            {{ $helperService.getHeight(180) }}
                          </option>
                          <option value="182">
                            {{ $helperService.getHeight(182) }}
                          </option>
                          <option value="185">
                            {{ $helperService.getHeight(185) }}
                          </option>
                          <option value="187">
                            {{ $helperService.getHeight(187) }}
                          </option>
                          <option value="190">
                            {{ $helperService.getHeight(190) }}
                          </option>
                          <option value="192">
                            {{ $helperService.getHeight(192) }}
                          </option>
                          <option value="195">
                            {{ $helperService.getHeight(195) }}
                          </option>
                          <option value="198">
                            {{ $helperService.getHeight(198) }}
                          </option>
                          <option value="200">
                            {{ $helperService.getHeight(200) }}
                          </option>
                          <option value="203">
                            {{ $helperService.getHeight(203) }}
                          </option>
                          <option value="205">
                            {{ $helperService.getHeight(205) }}
                          </option>
                          <option value="208">
                            {{ $helperService.getHeight(208) }}
                          </option>
                          <option value="210">
                            {{ $helperService.getHeight(210) }}
                          </option>
                          <option value="213">
                            {{ $helperService.getHeight(213) }}
                          </option>
                        </Field>
                        <ErrorMessage name="height" class="text-danger" />
                      </div>

                      <div
                        class="col-md-6 mb-2 form-group align-items-center mb-3">
                        <label for="">Marital Status</label>
                        <span class="text-danger">*</span>
                        <Field
                          as="select"
                          class="form-control form-select"
                          id="inputRole"
                          name="marrital_status"
                          v-model="detail.marital_status_id"
                          rules="required: Marital Status,true"
                          :validateOnInput="true">
                          <option value="">Select Status</option>
                          <option
                            v-for="(data, index) in marital_status"
                            :key="index"
                            :value="data.uuid">
                            {{ data.name }}
                          </option>
                        </Field>
                        <ErrorMessage
                          name="marrital_status"
                          class="text-danger" />
                      </div>
                      <div class="col-md-6">
                        <div class="form-group align-items-center mb-3">
                          <label>Education</label>
                          <span class="text-danger">*</span>

                          <Field
                            as="textarea"
                            id="education"
                            class="form-control"
                            name="education"
                            placeholder="Education"
                            v-model="detail.education_courses"
                            @keypress="$helperService.maxInput($event, 135)"
                            @keyup="trimMaxLength('education_courses', 135)"
                            rules="required:Education"
                            :validateOnInput="true" />
                        </div>
                        <ErrorMessage name="education" class="validation-msg" />
                      </div>

                      <div
                        class="col-md-6 mb-2 form-group align-items-center mb-3">
                        <label for="">Education Group</label>
                        <span class="text-danger">*</span>
                        <Field
                          as="select"
                          class="form-control form-select"
                          id="inputRole"
                          placeholder="Education Group"
                          name="education_group_id"
                          v-model="detail.education_group_id"
                          rules="required: education group,true"
                          :validateOnInput="true">
                          <option value="">Select Education Group</option>
                          <option
                            v-for="(data, index) in education_group"
                            :key="index"
                            :value="data.uuid">
                            {{ data.name }}
                          </option>
                        </Field>
                        <ErrorMessage
                          name="education_group_id"
                          class="text-danger" />
                      </div>
                      <div class="col-md-6">
                        <div class="form-group align-items-center mb-3">
                          <label>Income per year (Rs.)</label>
                          <span class="text-danger">*</span>
                          <Field
                            type="text"
                            id="income"
                            class="form-control"
                            name="income"
                            placeholder="Income Per Year"
                            v-model="detail.annual_income"
                            v-on:keypress="
                              $helperService.allowOnlyNumericValue($event)
                            "
                            rules="required:Income"
                            :validateOnInput="true" />
                        </div>
                        <ErrorMessage name="income" class="validation-msg" />
                      </div>

                      <div
                        class="col-md-6 mb-2 form-group align-items-center mb-3">
                        <label for="">Work Location</label>
                        <span class="text-danger">*</span>
                        <Field
                          as="select"
                          class="form-control form-select"
                          id="inputRole"
                          placeholder="Work Location"
                          name="working_place_taluka_id"
                          v-model="detail.working_place_taluka_id"
                          rules="required: work location,true"
                          :validateOnInput="true">
                          <option value="">Select Work Location</option>
                          <option
                            v-for="(data, index) in working_place"
                            :key="index"
                            :value="data.uuid">
                            {{ data.name }}
                          </option>
                        </Field>
                        <ErrorMessage
                          name="working_place_taluka_id"
                          class="text-danger" />
                      </div>
                      <div class="col-md-6">
                        <div class="form-group align-items-center mb-3">
                          <label></label>
                          <!-- <span class="text-danger">*</span> -->
                          <Field
                            type="text"
                            id="working_place_goan"
                            class="form-control"
                            name="working_place_goan"
                            placeholder="Working Area/Gaon"
                            v-model="detail.working_place_goan"
                            @keypress="$helperService.maxInput($event, 20)"
                            @keyup="trimMaxLength('working_place_goan', 20)"
                            rules="required: work location Area/Gaon,true"
                            :validateOnInput="true" />
                        </div>
                        <ErrorMessage
                          name="working_place_goan"
                          class="validation-msg" />
                      </div>
                      <div
                        class="col-md-6 mb-2 form-group align-items-center mb-3">
                        <label for="">Family Residence</label>
                        <!-- <span class="text-danger">*</span> -->
                        <Field
                          as="select"
                          class="form-control form-select"
                          id="inputRole"
                          placeholder="Family Residence"
                          name="family_residence_taluka_id"
                          v-model="detail.family_residence_taluka_id"
                          :validateOnInput="true">
                          <option value="">Select Taluka</option>
                          <option
                            v-for="(data, index) in family_residence"
                            :key="index"
                            :value="data.uuid">
                            {{ data.name }}
                          </option>
                        </Field>
                        <!-- <ErrorMessage
                          name="family_residence_taluka_id"
                          class="text-danger"
                        /> -->
                      </div>
                      <div class="col-md-6">
                        <div class="form-group align-items-center mb-3">
                          <label></label>
                          <!-- <span class="text-danger">*</span> -->
                          <Field
                            type="text"
                            id="goan"
                            class="form-control"
                            name="goan"
                            placeholder="Family Residence Area/Gaon"
                            v-model="detail.goan"
                            @keypress="$helperService.maxInput($event, 20)"
                            @keyup="trimMaxLength('goan', 20)"
                            rules="required: family residence Area/Gaon,true"
                            :validateOnInput="true" />
                        </div>
                        <ErrorMessage name="goan" class="validation-msg" />
                      </div>
                      <div class="col-md-4 mb-2 form-group align-items-center">
                        <label for="">Native District</label>
                        <span class="text-danger">*</span>
                        <Field
                          as="select"
                          class="form-control form-select"
                          id="inputRole"
                          placeholder="Native District"
                          name="native_place"
                          v-model="detail.native_place_district_id"
                          rules="required: native district,true"
                          :validateOnInput="true">
                          <option value="">Select Native District</option>
                          <option
                            v-for="(data, index) in native_place"
                            :key="index"
                            :value="data.uuid">
                            {{ data.name }}
                          </option>
                        </Field>
                        <ErrorMessage name="native_place" class="text-danger" />
                      </div>
                      <div class="col-md-4 mb-2 form-group align-items-center">
                        <label for="">Native Taluka</label>
                        <span class="text-danger">*</span>
                        <Field
                          as="select"
                          class="form-control form-select"
                          id="inputRole"
                          placeholder="Native Taluka"
                          name="native_place_taluka_id"
                          v-model="detail.native_place_taluka_id"
                          rules="required: native taluka,true"
                          :validateOnInput="true">
                          <option value="">Select Native Taluka</option>
                          <option
                            v-for="(data, index) in family_residence"
                            :key="index"
                            :value="data.uuid">
                            {{ data.name }}
                          </option>
                        </Field>
                        <ErrorMessage
                          name="native_place_taluka_id"
                          class="text-danger" />
                      </div>
                      <div class="col-md-4">
                        <div class="form-group align-items-center mb-3">
                          <label for="">Native Goan</label>
                          <span class="text-danger">*</span>
                          <Field
                            type="text"
                            id="native_place_goan"
                            class="form-control"
                            name="native_place_goan"
                            placeholder="Native Gaon"
                            v-model="detail.native_place_goan"
                            @keypress="$helperService.maxInput($event, 12)"
                            @keyup="trimMaxLength('native_place_goan', 12)"
                            rules="required: native Gaon,true"
                            :validateOnInput="true" />
                        </div>
                        <ErrorMessage
                          name="native_place_goan"
                          class="validation-msg" />
                      </div>

                      <div class="col-md-6">
                        <div class="form-group align-items-center mb-3">
                          <label>Email</label>
                          <span class="text-danger">*</span>
                          <Field
                            type="email"
                            id="email"
                            class="form-control"
                            name="email"
                            placeholder="Email"
                            v-model="detail.email"
                            @keypress="$helperService.maxInput($event, 32)"
                            @keyup="trimMaxLength('email', 32)"
                            rules="required:email|email"
                            :validateOnInput="true" />
                        </div>
                        <ErrorMessage name="email" class="validation-msg" />
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Mobile Number</label>
                          <span class="text-danger">*</span>
                          <Field
                            type="text"
                            name="phone"
                            placeholder="Phone Number"
                            v-slot="{ field }"
                            v-model="detail.mobile"
                            class="form-control mobile_no"
                            rules="required:mobile number"
                            :validateOnInput="true">
                            <PhoneCode
                              id="mobile"
                              placeholder="Mobile Number"
                              v-model:countryCode="detail.country_code"
                              v-model="detail.mobile_number"
                              v-model:dialCode="detail.mobile_country_code"
                              v-bind="field" />
                          </Field>
                        </div>
                        <ErrorMessage name="phone" class="validation-msg" />
                      </div>
                      <div class="col-md-6">
                        <div class="form-group align-items-center mb-3">
                          <label>Password</label>
                          <span class="text-danger">*</span>
                          <div class="input-group mb-3">
                            <Field
                              :type="newPasswordFieldType"
                              id="password"
                              name="password"
                              class="form-control password"
                              placeholder="Password"
                              v-model="detail.password"
                              v-on:keydown.space="$event.preventDefault()"
                              rules="required:password|minLength:6|password"
                              :validateOnInput="true" /><span
                              class="input-group-text"
                              id="basic-addon2"
                              style="border-radius: 0px 8px 8px 0px"
                              ><a
                                v-on:click="switchVisibilityNew"
                                class="psw-icon"
                                ><img :src="imageNew" width="20" /></a
                            ></span>
                          </div>
                          <ErrorMessage
                            name="password"
                            class="validation-msg" />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group align-items-center mb-3">
                          <label>Confirm Password</label>
                          <span class="text-danger">*</span>
                          <div class="input-group mb-3">
                            <Field
                              :type="PasswordFieldType"
                              id="confirm_password"
                              name="confirm password"
                              class="form-control password"
                              placeholder="Confirm Password"
                              v-on:keydown.space="$event.preventDefault()"
                              rules="required:confirm password|confirmed:@password"
                              :validateOnInput="true" /><span
                              class="input-group-text"
                              id="basic-addon2"
                              style="border-radius: 0px 8px 8px 0px"
                              ><a v-on:click="switchVisibility" class="psw-icon"
                                ><img :src="image" width="20" /></a
                            ></span>
                          </div>
                          <ErrorMessage
                            name="confirm password"
                            class="validation-msg" />
                        </div>
                      </div>
                    </div>
                    <div class="my-3 text-center">
                      <button
                        id="submit-Button"
                        class="btn btn-lg btn-block btn-brand-1 px-5">
                        Register
                      </button>
                    </div>
                    <div class="text-center mb-2">
                      <p class="mb-0 mr-1">
                        By clicking on Register you accept our
                        <a
                          v-on:click="termsandcondition()"
                          class="cursor-pointer"
                          >Terms & Conditions
                        </a>
                      </p>
                    </div>
                    <div class="text-center">
                      <p class="mb-0 mr-1">
                        Already have an account ?
                        <a class="cursor-pointer" v-on:click="loginModal()">
                          &nbsp; Login</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
    <div class="spx-modal-background"></div>
  </div>
  <TextModal ref="otpModal">
    <div class="modal-dialog modal-dialog-centered" style="margin: 0px">
      <div class="modal-content">
        <div class="modal-header px-md-5 border-0">
          <h5 class="modal-title" id="loginModalLabel">OTP Confirmation</h5>
          <button type="button" class="btn-close" v-on:click="close()"></button>
        </div>
        <div class="modal-body pt-0 text-center">
          <p class="text-secondary font-14">
            Please enter the verification code sent to your
            <br />registered mobile number
          </p>
          <Form ref="otpFormNew" @Submit="verifyOtp()">
            <div class="form-group otp-element mb-0 col-md-10 mx-auto mb-4">
              <div class="d-flex justify-content-between">
                <Field
                  id="codeBox1"
                  type="text"
                  class="otp-control"
                  maxlength="1"
                  name="otp1"
                  v-on:keyup="onKeyUpEvent(1, $event)"
                  v-on:keyup.enter="verifyOtp()"
                  v-on:focus="onFocusEvent(1)"
                  rules="required"
                  :validateOnInput="true" />
                <Field
                  id="codeBox2"
                  type="text"
                  class="otp-control"
                  maxlength="1"
                  name="otp2"
                  v-on:keyup="onKeyUpEvent(2, $event)"
                  v-on:keyup.enter="verifyOtp()"
                  v-on:focus="onFocusEvent(2)"
                  rules="required"
                  :validateOnInput="true" />
                <Field
                  id="codeBox3"
                  type="text"
                  class="otp-control"
                  maxlength="1"
                  name="otp3"
                  v-on:keyup="onKeyUpEvent(3, $event)"
                  v-on:keyup.enter="verifyOtp()"
                  v-on:focus="onFocusEvent(3)"
                  rules="required"
                  :validateOnInput="true" />
                <Field
                  id="codeBox4"
                  type="text"
                  class="otp-control"
                  maxlength="1"
                  name="name"
                  v-on:keyup="onKeyUpEvent(4, $event)"
                  v-on:keyup.enter="verifyOtp()"
                  v-on:focus="onFocusEvent(4)"
                  rules="required: OTP"
                  :validateOnInput="true" />
              </div>
              <ErrorMessage name="name" class="text-danger" />
            </div>

            <button class="btn btn-brand-1 btn-block" id="otp-button">
              Submit
            </button>
            <div class="mt-3">
              <!-- <p id="otp_timer" class="font-20 mb-2" style="color: #666666">
              00:0
            </p> -->
              <!-- <vue-countdown
              v-if="counting"
              :time="30000"
              @end="onCountdownEnd"
              v-slot="{ totalSeconds }"
              >{{ totalSeconds }}
            </vue-countdown> -->
              <p>
                <a
                  v-on:click="resendOtp()"
                  class="text-color-2 font-16 text-primary cursor-pointer">
                  Resend
                </a>
              </p>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </TextModal>
  <TextModal ref="loginModal">
    <Form @submit="getLogin()" ref="loginForm">
      <div class="row col-12 px-md-5 border-0 p-2 text-align-last-center">
        <div class="col-11" style="text-align-last: center">
          <h5 class="modal-title" id="loginModalLabel">Login</h5>
        </div>
        <div class="col-1" style="text-align-last: end">
          <button
            type="button"
            id="login-close"
            class="btn-close"
            v-on:click="$refs.loginModal.closeModal()"></button>
        </div>
      </div>
      <div class="modal-body pt-0">
        <ul
          class="nav nav-pills mb-3 tab-style-1"
          id="login-tab"
          role="tablist">
          <li class="nav-item" role="presentation">
            <a
              class="nav-link active"
              id="email-tab"
              data-bs-toggle="pill"
              href="#tab_1"
              role="tab"
              aria-controls="tab_1"
              aria-selected="true"
              v-on:click="changeTab('email')"
              >Email Address
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a
              class="nav-link"
              id="phone-tab"
              data-bs-toggle="pill"
              href="#tab_2"
              role="tab"
              aria-controls="tab_2"
              aria-selected="false"
              v-on:click="changeTab('mobile')"
              >Mobile Number</a
            >
          </li>
        </ul>
        <div class="tab-content form-style" id="login-tabContent">
          <div
            v-if="currentTab == 'email'"
            :class="
              currentTab == 'email'
                ? 'tab-pane fade show active'
                : 'tab-pane fade'
            "
            id="tab_1"
            role="tabpanel"
            aria-labelledby="eamil-tab">
            <div class="form-group">
              <label>Email Address</label>
              <Field
                type="email"
                id="email"
                class="form-control"
                name="email"
                placeholder="Email"
                v-model="loginData.email"
                rules="required:email"
                :validateOnInput="true" />
            </div>
            <ErrorMessage name="email" class="validation-msg" />
          </div>
          <div
            v-if="currentTab == 'mobile'"
            :class="
              currentTab == 'mobile'
                ? 'tab-pane fade show active'
                : 'tab-pane fade'
            "
            id="tab_2"
            role="tabpanel"
            aria-labelledby="phone-tab">
            <div class="form-group">
              <label>Mobile Number</label>
              <Field
                type="text"
                id="mobile_no"
                class="form-control mobile_no"
                name="mobile"
                placeholder="Mobile Number"
                v-slot="{ field }"
                v-model="loginData.mobile"
                rules="required:mobile number"
                :validateOnInput="true">
                <PhoneCode
                  id="mobile"
                  placeholder="Mobile Number"
                  v-model:countryCode="loginData.country_code"
                  v-model="loginData.mobile"
                  v-model:dialCode="loginData.dial_code"
                  v-bind="field" />
              </Field>
            </div>
            <ErrorMessage name="mobile" class="validation-msg" />
          </div>
          <div class="form-group align-items-center mb-3">
            <label>Password</label>
            <div class="input-group mb-3">
              <Field
                :type="newPasswordFieldType"
                id="password"
                name="password"
                class="form-control password"
                placeholder="Password"
                v-model="loginData.password"
                v-on:keydown.space="$event.preventDefault()"
                rules="required:password|minLength:6|password"
                :validateOnInput="true" /><span
                class="input-group-text"
                id="basic-addon2"
                style="border-radius: 0px 8px 8px 0px"
                ><a v-on:click="switchVisibilityNew" class="psw-icon"
                  ><img :src="imageNew" width="20" /></a
              ></span>
            </div>
            <ErrorMessage name="password" class="validation-msg" />
          </div>
          <div
            class="d-flex justify-content-between align-items-center text-center">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="rememberMe" />
              <label class="form-check-label" for="rememberMe">
                Remember Me
              </label>
            </div>
            <p class="text-md-right mb-0">
              <a v-on:click="ShowForget()" class="text-color-2 cursor-pointer">
                Forgot Password ?</a
              >
            </p>
          </div>
          <div class="my-3 text-center">
            <button
              id="login-button"
              class="btn btn-lg btn-block btn-brand-1 px-5">
              Login
            </button>
          </div>
          <!-- <div class="my-3 text-center">
            <button class="btn btn-lg btn-block btn-brand-1 px-5" id="login-button">
              Login
            </button>
          </div> -->
          <div class="d-flex justify-content-center">
            <p class="mb-0 mr-1 font-less">Don't have an account ?</p>
            <a
              data-bs-dismiss="modal"
              aria-label="Close"
              v-on:click="showSignupModal()"
              class="text-color-2 cursor-pointer font-less">
              Register Free</a
            >
          </div>
        </div>
      </div>
    </Form>
  </TextModal>
  <TextModal ref="forgetModal">
    <!-- <div
    class="modal fade login-modal"
    id="ForgotPassword"
    tabindex="-1"
    aria-labelledby="loginModalLabel"
    aria-hidden="true"
  > -->
    <div>
      <Form @submit="forgotPassword()" ref="forgetForm">
        <div class="row col-12 px-md-5 border-0 p-4 text-align-last-center">
          <div class="col-11" style="text-align-last: center">
            <h5 class="modal-title ml-2" id="loginModalLabel">
              Forgot Password ?
            </h5>
          </div>
          <div class="col-1" style="text-align-last: end">
            <button
              type="button"
              id="login-close"
              class="btn-close"
              v-on:click="$refs.forgetModal.closeModal()"></button>
          </div>
        </div>
        <div class="modal-body pt-0 form-style">
          <div class="form-group">
            <label for="">Enter your Email Id</label>
            <Field
              type="email"
              id="forget_email"
              class="form-control"
              name="forget_email"
              placeholder="Email"
              v-model="forgotData.email"
              rules="required:email|email"
              :validateOnInput="true" />
          </div>
          <ErrorMessage name="forget_email" class="validation-msg" />
          <div class="text-center">
            <button class="btn btn-brand-1 btn-block" id="forgot-button">
              Submit
            </button>
          </div>
        </div>
      </Form>
    </div>
  </TextModal>
</template>

<script>
import TextModal from "./TextModal.vue";
import PhoneCode from "./PhoneCodePicker/PhoneCode";
import { Form, Field, ErrorMessage } from "vee-validate";
import CustomDatepicker from "@/components/DatePicker.vue";
export default {
  name: "SignUp",
  components: {
    Form,
    Field,
    ErrorMessage,
    CustomDatepicker,
    PhoneCode,
    TextModal,
  },
  data() {
    return {
      isShowModal: false,
      // date: moment(new Date()).add(-18, "year"),
      newPasswordFieldType: "password",
      PasswordFieldType: "password",
      image: "/images/show-psw.svg",
      file: undefined,
      imageNew: "/images/show-psw.svg",
      detail: {
        dob: "",
        dob_validate: "",
        working_place_taluka_id: "",
        marital_status_id: "",
        education_group_id: "",
        family_residence_taluka_id: "",
        native_place_district_id: "",
      },
      marital_status: [],
      education_group: [],
      working_place: [],
      family_residence: [],
      native_place: [],
      currentTab: "email",
      loginData: {
        role: "USER",
      },
      forgotData: {},
      url: "",
      counting: true,
    };
  },
  mounted() {
    this.getMaritalStatus("MARITAL_STATUS");
    this.getEducationGroup("EDUCATION_GROUP");
    this.getWorkingPlace();
    this.getFamilyResidence();
    this.getNativePlace();
  },
  methods: {
    trimMaxLength(key, limit) {
      var field = key.split(".")[0];
      var field2 = key.split(".")[1];
      if (field && field2) {
        if (
          this.detail[field] &&
          this.detail[field][field2] &&
          this.detail[field][field2].length > limit
        ) {
          this.detail[field][field2] = this.detail[field][field2].substring(
            0,
            limit
          );
        }
      } else {
        if (this.detail[field] && this.detail[field].length > limit) {
          this.detail[field] = this.detail[field].substring(0, limit);
        }
      }
    },
    close() {
      localStorage.clear();
      this.$refs.otpModal.closeModal();
    },
    allowedDates() {
      return new Date();
    },
    termsandcondition() {
      window.open("/terms");
    },
    showModal() {
      document.getElementById("preview").src = "/images/placeholder-image.jpg";
      this.$refs.registerForm.resetForm();
      this.isShowModal = true;
    },
    closedModal() {
      this.isShowModal = false;
    },
    selectGender(gender) {
      this.detail.gender = gender;
    },
    switchVisibilityNew() {
      this.newPasswordFieldType =
        this.newPasswordFieldType === "password" ? "text" : "password";
      this.imageNew =
        this.imageNew === "/images/show-psw.svg"
          ? "/images/hide-psw.svg"
          : "/images/show-psw.svg";
    },
    switchVisibility() {
      this.PasswordFieldType =
        this.PasswordFieldType === "password" ? "text" : "password";
      this.image =
        this.image === "/images/show-psw.svg"
          ? "/images/hide-psw.svg"
          : "/images/show-psw.svg";
    },
    changeBOD(e) {
      var date = new Proxy(e, {}).date;
      this.detail.dob = date.format("YYYY-MM-DD");
      this.detail.dob_validate = date.format("YYYY-MM-DD");
    },
    signup() {
      this.$api
        .postAPI({
          _action: "/user/signup",
          _body: this.detail,
          _buttonId: "submit-Button",
        })
        .then((res) => {
          if (res && res.access_token) {
            localStorage.setItem("access_token", res.access_token);
            localStorage.setItem("userId", res.id);
            localStorage.setItem("email", this.detail.mobile);
            if (this.file) {
              this.uploadImage(this.detail.id);
              return;
            }
            // localStorage.setItem("email", this.detail.email);
            this.closedModal();
            // this.counting = true;
            this.$refs.otpModal.showModal();
            this.getMeCall();
          }
        })
        .catch(() => {
          localStorage.removeItem("access_token");
        });
    },
    uploadImage(id) {
      if (!this.file) {
        // this.$router.go(-1);
        return;
      }
      this.$api
        .uploadImageAPI({
          _action: "/user/add/photo",
          _key: "image",
          _file: this.file,
          _body: {
            id: id,
            type: "REGISTER",
          },
          _buttonId: "submit-Button",
        })
        .then(() => {
          // this.$notify({
          //   type: "success",
          //   text: res.message,
          // });
          this.isShowModal = false;
          // this.counting = true;
          this.$refs.otpModal.showModal();
          this.onFocusEvent(1);
          this.getMeCall();
        });
    },
    getCodeBoxElement(index) {
      return document.getElementById("codeBox" + index);
    },
    onKeyUpEvent(index, event) {
      if (index < 4) {
        const eventCode = event.which || event.keyCode;
        if (this.getCodeBoxElement(index).value.length == 1) {
          if (index !== 4) {
            this.getCodeBoxElement(index + 1).focus();
          } else {
            this.getCodeBoxElement(index).blur();
            this.validate = false;
          }
        }
        if (eventCode === 8 && index !== 1) {
          this.getCodeBoxElement(index - 1).focus();
          this.validate = true;
        } else {
          this.validate = false;
        }
      }
    },
    onFocusEvent(index) {
      if (index < 4) {
        for (var item = 1; item < index; item++) {
          const currentElement = this.getCodeBoxElement(item);
          if (!currentElement.value) {
            currentElement.focus();
            break;
          }
        }
      }
    },

    verifyOtp() {
      var obj = {};
      obj.email = this.detail.mobile;
      obj.otp =
        document.getElementById("codeBox1").value +
        "" +
        document.getElementById("codeBox2").value +
        "" +
        document.getElementById("codeBox3").value +
        "" +
        document.getElementById("codeBox4").value;
      if (obj.otp.length == 4) {
        this.$api
          .putAPI({
            _action: "verify/otp",
            _body: obj,
            _buttonId: "otp-button",
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.getMeCall();
            this.$router.push("/dashboard");
          })
          .catch(() => {});
      } else {
        this.validate = true;
      }
    },
    resendOtp() {
      var obj = {};
      obj.email = this.detail.mobile;
      this.$api
        .postAPI({
          _action: "resend/otp",
          _body: obj,
        })
        .then((res) => {
          if (res) {
            this.$notify({
              type: "success",
              text: res.message,
            });
          }
        })
        .catch(() => {});
    },
    getMaritalStatus(type) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + type,
        })
        .then((res) => {
          this.marital_status = res.list;
        })
        .catch(() => {});
    },
    getEducationGroup(type) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + type,
        })
        .then((res) => {
          this.education_group = res.list;
        })
        .catch(() => {});
    },
    getWorkingPlace() {
      this.$api
        .getAPI({
          _action: "/work-location/list",
        })
        .then((res) => {
          this.working_place = res;
        })
        .catch(() => {});
    },
    getFamilyResidence() {
      this.$api
        .getAPI({
          _action: "/taluka/list",
        })
        .then((res) => {
          this.family_residence = res;
        })
        .catch(() => {});
    },
    getNativePlace() {
      this.$api
        .getAPI({
          _action: "/district/list",
        })
        .then((res) => {
          this.native_place = res;
        })
        .catch(() => {});
    },
    loginModal() {
      this.closedModal();
      this.loginData = {
        role: "USER",
      };
      this.$refs.loginForm.resetForm();
      this.$refs.loginModal.showModal();
    },
    ShowForget() {
      this.$refs.loginModal.closeModal();
      (this.forgotData.email = ""), this.$refs.forgetForm.resetForm();
      this.$refs.forgetModal.showModal();
    },
    showSignupModal() {
      this.$refs.loginModal.closeModal();
      this.showModal();
    },
    changeTab(tab) {
      this.currentTab = tab;
    },
    getLogin() {
      if (this.currentTab == "mobile") {
        this.url = "/mobile-login";
      }
      if (this.currentTab == "email") {
        this.url = "/login";
      }
      this.$api
        .postAPI({
          _action: this.url,
          _body: this.loginData,
          _buttonId: "login-button",
        })
        .then((res) => {
          localStorage.setItem("access_token", res.access_token);
          this.getMeCall();
          document.getElementById("login-close").click();
          this.$router.push("/dashboard");
        });
    },
    forgotPassword() {
      this.$api
        .postAPI({
          _action: "/forgot/password",
          _body: this.forgotData,
          _buttonId: "forgot-button",
        })
        .then((res) => {
          this.$router.push("/home");
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.$refs.forgetModal.closeModal();
          // this.$router.push("/reset-password?T="+res.token);
        });
    },
    getMeCall() {
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          this.$store.commit("setUser", res);
          if (res.is_membership_subscribed) {
            localStorage.setItem(
              "is_membership_subscribed",
              res.is_membership_subscribed
            );
          } else {
            localStorage.setItem("is_membership_subscribed", "N");
          }
          if (res.gender) {
            localStorage.setItem("gender", res.gender);
          }
        })
        .catch(() => {});
    },
    removeImage() {
      this.file = undefined;
      this.detail.images = null;
      document.getElementById("preview").src = "/images/placeholder-image.jpg";
    },
    onChange(e) {
      let files = e.target.files;
      if (
        files[0].type.toLowerCase() != "image/jpeg" &&
        files[0].type.toLowerCase() != "image/png"
      ) {
        alert("Invalid file format please use jpeg or png file.");
        return;
      }
      // const size = (files[0].size / 1024 / 1024).toFixed(2);
      // if (size > 10) {
      //   alert("File must be less then 10 MB");
      //   return;
      // }
      const sizeInKB = files[0].size / 1024; // Convert to KB
      if (sizeInKB > 400) {
        alert("Photo size should not exceed 400 KB");
        return;
      }
      var tmppath = URL.createObjectURL(files[0]);
      this.file = files[0];
      document.getElementById("preview").src = tmppath;
    },

    // onCountdownEnd: function () {
    //   this.counting = false;
    // },
  },
};
</script>
<style>
.dp__input::placeholder {
  opacity: 0.7 !important;
  background-color: white !important;
}
.placeholder {
  color: #fff;
  opacity: 1;
}
</style>
